export enum FiltresListeTaxesEnum {
	annee = 'annee',
	reference = 'reference',
	status = 'status',
	page = 'page',
	avis = 'avis',
	societe = 'societe'
}

// Enumération des statuts des avis
export enum statutListeTaxesEnum {
	all = 'Tous',
	VALIDEE = 'Validée',
	GENEREE = 'Générée',
	TRANSMISE = 'Transmise',
}

export enum enteteTableauAffichageListeEnum {
	annee_reddition = 'Reddition',
	immeuble = 'Immeuble',
	societe = 'Société',
	cotisations = 'Cotisations',
	frais = 'Frais',
	total = 'Total à payer',
	statut = 'Statut',
	date = 'Date',
	n_depense = 'N° dépense',
	referenceAvis= 'Référence avis'
}